// src/pages/BuilderPage.jsx
import React from "react";
import YouTubeThumbnail from "../components/YouTubeThumbnail";

const BuilderPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-10 grid place-items-center">
      <YouTubeThumbnail
        title="Lerne Cinema4D mit Denis"
        author="The Original Bitter"
        thumbnailUrl="https://img.youtube.com/vi/abc123/hqdefault.jpg"
      />
    </div>
  );
};

export default BuilderPage;
